import { create } from 'zustand'

type GlobalState = {
  isLoginPopupOpen: boolean
}

type GlobalAction = {
  onLoginPopupOpenChange: () => void
  setLoginPopupOpen: (value: boolean) => void
}

const initialState: GlobalState = {
  isLoginPopupOpen: false,
}

export const useGlobalStore = create<GlobalAction & GlobalState>((set) => {
  return {
    ...initialState,
    onLoginPopupOpenChange: () =>
      set((state) => ({ isLoginPopupOpen: !state.isLoginPopupOpen })),
    setLoginPopupOpen: (value) => set({ isLoginPopupOpen: value }),
  }
})
